export default function menuSlide(){
  const menuOpen = document.getElementById('menu-open')
  const menuClose = document.getElementById('menu-close')
  const menuNav = document.querySelector('.m__admin-header__menu')
  const menuNavBg = document.querySelector('.m__admin-header__menu-background')

  if(menuOpen) {
    menuOpen.addEventListener('click', () => {
      menuNav.classList.add('open')
    })
    menuClose.addEventListener('click', () => {
      menuNav.classList.remove('open')
    })
    menuNavBg.addEventListener('click', () => {
      menuNav.classList.remove('open')
    })
  }
}
